import { render, staticRenderFns } from "./QuotaholdersOperationsTable.vue?vue&type=template&id=25f53f29&"
import script from "./QuotaholdersOperationsTable.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersOperationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports